import { createContext } from 'react';
import DateFormatter from '@/Util/DateFormatter';

const DateFormatterContext = createContext<DateFormatter>(new DateFormatter());

export default DateFormatterContext;
